import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
import heroImg   from '../images/bradenton_florida_1600.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image41.webp';
import slideImg2 from '../images/image95.webp';
import slideImg3 from '../images/image42.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const southBradentonConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'South Bradenton Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in South Bradenton, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_south_bradenton',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving South Bradenton',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in South Bradenton Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring reliable, expert tree care to the 
     neighborhoods and properties of <strong>South Bradenton</strong>. Overgrown oaks 
     dropping limbs on driveways, palms leaning toward homes after storms, and thick 
     canopy growth blocking gutters and pressing against rooftops these are the kinds 
     of jobs our team handles every day, safely and professionally.`,

    `We specialize in <strong>dangerous and overgrown tree situations</strong> including 
     full tree removals on tight residential lots, precision canopy reductions, storm 
     response cleanup, and trimming that targets specific hazards without damaging the 
     rest of your landscape. We come prepared and leave your property clean.`,

    `<strong>Sam's Tree Service</strong> provides trusted, affordable tree care throughout 
     <strong>South Bradenton</strong> and across <strong>Manatee County</strong> 
     giving your property the protection it needs through Florida's demanding storm seasons.`,
  ],

  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'South Bradenton, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_SouthBradenton = () => <LocationPage config={southBradentonConfig} />;
export default Services_SouthBradenton;
